import { LoadingSpinner } from "@mapmaker/ui";
import Centered from "./Centered";

export default function CenteredLoader() {
  return (
    <Centered>
      <LoadingSpinner />
    </Centered>
  );
}
